<template>
  <div class="row">
    <div class="col-md-12">
      <TableWrapper
        name="tbl_finance_receipt"
        :columns="columns"
        :row-class-name="rowClassName"
        :url="url"
        :search-form-fields="formFields"
        :offset-height="offsetHeight"
        :show-add="false"
        :show-summary="receiptTotalLoadPermitted"
        :handle-summary="handleSummary"
        :show-column-visible="true"
        @on-ready="onReady"
      />
    </div>
  </div>
</template>

<script>
import TableWrapper from '@/components/table-wrapper'
import request from '@/utils/request'
import { isAdmin, hasPermission } from '@/utils/app'
export default {
  name: 'ReceiptList',
  components: {
    TableWrapper
  },
  data() {
    return {
      url: this.$config.apiContextPath + '/receipt?status=1',
      action: '',
      total: 0,
      garages: this.loadGarages(),
      quotations: this.loadQuotations()
    }
  },
  computed: {
    receiptTotalLoadPermitted() {
      return isAdmin() || hasPermission('PEM_RECEIPT_TOTAL')
    },
    offsetHeight() {
      return 320 + (!this.receiptTotalLoadPermitted && -50)
    },
    formFields() {
      return {
        action: '',
        fields: [
          { label: '充值日期', width: '200px', options: {
            shortcuts: [
              {
                text: '一周',
                value() {
                  const end = new Date()
                  const start = new Date()
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
                  return [start, end]
                }
              },
              {
                text: '一个月',
                value() {
                  const end = new Date()
                  const start = new Date()
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
                  return [start, end]
                }
              },
              {
                text: '三个月',
                value() {
                  const end = new Date()
                  const start = new Date()
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
                  return [start, end]
                }
              }
            ]
          }, placeholder: '请选择充值日期...', type: 'dateranger', hidden: true },
          { label: '绑定车库', placeholder: '请选择绑定车库...', name: 'parkingId', width: '200px', type: 'select', options: this.garages },
          { label: '车辆用户', placeholder: '请输入用户姓名...', name: 'member', width: '140px', type: 'input' },
          { label: '用户手机', placeholder: '请输入用户手机...', name: 'mobile', width: '140px', type: 'input' },
          { label: '车辆编码', placeholder: '请输入车辆编号...', name: 'planetNumber', width: '140px', type: 'input' },
          { label: '充值套餐', placeholder: '请选择充值套餐...', name: 'productId', width: '140px', type: 'select', options: this.quotations, hidden: true },
          { label: '充值金额', placeholder: '请输入充值金额...', name: 'amount', width: '140px', type: 'input', hidden: true },
          { label: '是否临停', placeholder: '请选择是否临停...', name: 'isTemporary', width: '140px', type: 'select', hidden: true, options: [
            { label: '临停', value: 1 },
            { label: '包月', value: 0 }
          ] },
          { label: '交易状态', placeholder: '请选择交易状态...', name: 'type', width: '140px', type: 'select', options: [
            { label: '已退回', value: 1 },
            { label: '已支付', value: 0 }
          ] },
          { label: '运营模式', placeholder: '请选择运营模式...', name: 'businessType', width: '140px', type: 'select', hidden: true, options: this.$config.parkingBusinessType }
        ]
      }
    },
    columns() {
      return [
        { title: '序号', type: 'index', width: 80, align: 'center', key: '_index', disabled: true },
        { title: '绑定车库', align: 'left', key: 'parking', width: 150, ellipsis: true, tooltip: true, sortable: true,
          render: (h, params) => {
            return h('span', {}, params.row.parking || '---')
          }
        },
        { title: '车辆编码', align: 'center', key: 'planetNumber', sortable: true,
          render: (h, params) => {
            return h('span', {}, params.row.planetNumber || '---')
          }
        },
        { title: '车辆用户', align: 'center', key: 'member', sortable: true,
          render: (h, params) => {
            return h('span', {}, params.row.member || '---')
          }
        },
        { title: '用户手机号', align: 'center', key: 'mobile', sortable: true,
          render: (h, params) => {
            return h('span', {}, params.row.mobile || '---')
          }
        },
        { title: '充值套餐', align: 'left', key: 'productName', sortable: true, ellipsis: true, tooltip: true,
          render: (h, params) => {
            return h('span', {}, params.row.productName || '---')
          }
        },
        { title: '业务单号', align: 'center', key: 'transactionId', sortable: true, ellipsis: true, tooltip: true,
          render: (h, params) => {
            return h('span', {}, params.row.transactionId || '---')
          }
        },
        { title: '业务凭证号', align: 'center', key: 'outTradeNo', sortable: true, ellipsis: true, tooltip: true,
          render: (h, params) => {
            return h('span', {}, params.row.outTradeNo || '---')
          }
        },
        { title: '交易金额', align: 'center', key: 'amount', sortable: true, width: 110, sum: true,
          render: (h, params) => {
            return h('span', {
              style: { color: params.row.amount > 0 ? '' : 'red' }
            }, params.row.amount)
          }
        },
        // { title: '创建时间', align: 'center', key: 'createTime', sortable: true, width: 160,
        //   render: (h, params) => {
        //     return h('span', {}, params.row.createTime || '---')
        //   }
        // },
        { title: '记账时间', align: 'center', key: 'payTime', sortable: true, width: 160,
          render: (h, params) => {
            return h('span', {}, params.row.payTime || '---')
          }
        },
        // { title: '支付类型', align: 'center', key: 'payType', sortable: true, width: 120,
        //   render: (h, params) => {
        //     return h('span', {}, params.row.payType === 0 ? '微信支付' : '支付宝')
        //   }
        // },
        { title: '临停', width: 80, align: 'center', key: 'isTemporary',
          render: (h, params) => {
            return h('span', {}, params.row.isTemporary ? '是' : '否')
          }
        },
        { title: '状态', align: 'center', key: 'status', sortable: true, width: 90,
          render: (h, params) => {
            return h('span', {
              style: { color: params.row.amount < 0 ? 'red' : (params.row.status === 1 ? 'green' : (params.row.status === 0 ? '#000' : (params.row.status === 2 ? 'blue' : 'red'))) }
            }, params.row.amount < 0 ? '已退回' : (params.row.status === 1 ? '已支付' : (params.row.status === 0 ? '未支付' : (params.row.status === 2 ? '已退回' : '支付失败'))))
          }
        },
        { title: '操作人员', align: 'center', key: 'operator', width: 110, sortable: true, ellipsis: true, tooltip: true, hidden: true,
          render: (h, params) => {
            return h('span', {}, params.row.operator || '---')
          }
        }
      ]
    }
  },
  methods: {
    async getTotal(params) {
      request({
        url: this.$config.apiContextPath + '/receipt/total?status=1',
        params: params,
        method: 'get'
      }).then(res => {
        this.total = res.data
      }).catch(error => {
        console.log(error)
      })
    },
    rowClassName(row, index) {
      return 'row-' + (row.isTemporary ? 'gray' : 'lightblue')
    },
    async loadGarages() {
      await request({
        url: this.$config.apiContextPath + '/parking/list',
        method: 'get'
      }).then(res => {
        this.garages = []
        const items = res.data
        items.forEach(i => {
          this.garages.push({ label: i.name, value: i.id })
        })
      }).catch(error => {
        console.log(error)
        this.garages = []
      })
    },
    async loadQuotations() {
      await request({
        url: this.$config.apiContextPath + '/quotation?fetchAll=true',
        method: 'get'
      }).then(res => {
        this.quotations = []
        const items = res.data.content
        items.forEach(i => {
          this.quotations.push({ label: i.name, value: i.id })
        })
      }).catch(error => {
        console.log(error)
        this.produquotationscts = []
      })
    },
    async onReady(data, params) {
      if (this.receiptTotalLoadPermitted) {
        await this.getTotal(params)
      }
    },
    getParams() {
      const params = {}
      const fields = this.formFields
      for (var name in fields) {
        if (fields[name] || fields[name] === 0) params[name] = fields[name]
      }
      return params
    },
    handleSummary: function({ columns, data }) {
      // this.getTotal()
      const _that = this
      const sums = {}
      columns.forEach((column, index) => {
        const key = column.key
        if (index === 0) {
          sums[key] = {
            key,
            value: '合计'
          }
          return
        } else {
          sums[key] = {
            key,
            value: column.sum ? _that.total : ''
          }
        }
      })
      // sums[undefined] = { key: undefined, value: '总价' }
      // console.log(sums)
      return sums
    }
  }
}
</script>

